import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IMapOptions } from "../interfaces/mapoptions";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { PoiSearch } from "../api/poisearch";
import { composePathPoi, composePathRoot } from "../api/utility";
import PoiItemAddress from './poiitemaddress';
import PoiItemCategory from './poiitemcategory';
import YelpStars from "./yelpstars";

interface IPoiDetailsProps {
    poi: PoiSearch;
}

const PoiItem = ({ poi }: IPoiDetailsProps) => {
    const navigate = useNavigate();
    const { adr1, adr2, poiname, travel } = useParams();
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    const handleClickDetails = (event) => {
        const url = composePathPoi(adr1, adr2, poiname, travel, poi.result.id, mapoptions.code);
        navigate(url);
    }


    const result = poi.result;
    const title = result.name || 'Point of Interest';
    let className = "poi poi-item" + poi.poiindex;
    if (result.isClosed) {
        className += " poi-closed";
    }

    const location = result.location;

    const addressLines = location.displayAddress.map(function (adr, idx) {
        return <PoiItemAddress addressline={adr} key={idx} />;
    });

    let categoryLines: Array<JSX.Element> = null;
    if (result.categories) {
        categoryLines = result.categories.map(function (category, idx) {
            const poiLink = mapoptions.basename+composePathRoot(adr1, adr2, category.title, travel, mapoptions.code);

            return (<PoiItemCategory link={poiLink} category={category.title} key={idx} />);
        });
    }

    const reviewname = result.reviewCount === 1 ? "review" : "reviews";

    let imageStyle = {};

    if (result.imageUrl) {
        imageStyle["backgroundImage"] = 'url(' + result.imageUrl.replace("/o.jpg", "/ms.jpg") + ')';
    }

    /* Larger images http://stackoverflow.com/questions/17965691/yelp-api-ios-getting-a-larger-image */

    return (
        <article className={className} onClick={handleClickDetails}>
            <div className="data">
                <div className='pin-title'>
                    <div className="pin-index">{poi.poiindex + 1}</div>
                    <div className="pin-name"><h3>{title}</h3></div>
                </div>
                <div className="address">
                    <span className="street">{addressLines}</span>

                </div>
                <div className="categories">
                    <ul>
                        {categoryLines}
                    </ul>
                </div>
                <div className="reviews">
                    <div className="">
                        <YelpStars rating={result.rating} />
                    </div>
                    <div className="count">
                        {result.reviewCount} {reviewname}
                    </div>
                </div>
            </div>
            <div className="image" style={imageStyle} />
        </article>
    );
};

export default PoiItem;
